export default __webpack_public_path__ + "static/media/overlay-1.e20fd975.jpg";